export type CurrencyItem = {
  language: string
  currency: string
  symbol?: string
}

export const CURRENCIES_LIST: Record<string, CurrencyItem> = {
  NN: { language: 'ru', currency: 'RUB', symbol: '₽' },
  BD: { language: 'bn', currency: 'BDT', symbol: '৳' },
  BE: { language: 'nl', currency: 'EUR', symbol: '€' },
  BF: { language: 'fr', currency: 'XOF', symbol: 'CFA' },
  BG: { language: 'bg', currency: 'EUR', symbol: '€' },
  BA: { language: 'bs', currency: 'EUR', symbol: '€' },
  BB: { language: 'en', currency: 'BBD' },
  WF: { language: 'fr', currency: 'USD', symbol: '$' },
  BL: { language: 'fr', currency: 'EUR', symbol: '€' },
  BM: { language: 'en', currency: 'BMD' },
  BN: { language: 'ms', currency: 'BND', symbol: '$' },
  BO: { language: 'es', currency: 'BOB', symbol: 'Bs' },
  BH: { language: 'ar', currency: 'BHD', symbol: 'د.ب.' },
  BI: { language: 'fr', currency: 'BIF', symbol: 'FBu' },
  BJ: { language: 'fr', currency: 'XOF', symbol: 'CFA' },
  BT: { language: 'dz', currency: 'BTN' },
  JM: { language: 'en', currency: 'JMD', symbol: '$' },
  BV: { language: 'no', currency: 'NOK', symbol: 'kr' },
  BW: { language: 'en', currency: 'BWP', symbol: 'P' },
  WS: { language: 'sm', currency: 'USD', symbol: '$' },
  BQ: { language: 'nl', currency: 'USD', symbol: '$' },
  BR: { language: 'pt', currency: 'BRL', symbol: 'R$' },
  BS: { language: 'en', currency: 'BSD' },
  JE: { language: 'en', currency: 'GBP', symbol: '£' },
  BY: { language: 'be', currency: 'BYN', symbol: 'BYN' },
  BZ: { language: 'en', currency: 'BZD', symbol: '$' },
  RU: { language: 'ru', currency: 'RUB', symbol: '₽.' },
  RW: { language: 'rw', currency: 'USD', symbol: '$' },
  RS: { language: 'sr', currency: 'EUR', symbol: '€' },
  TL: { language: 'pt', currency: 'USD', symbol: '$' },
  RE: { language: 'fr', currency: 'EUR', symbol: '€' },
  TM: { language: 'tk', currency: 'USD', symbol: '$' },
  TJ: { language: 'tg', currency: 'USD', symbol: '$' },
  RO: { language: 'ro', currency: 'EUR', symbol: '€' },
  TK: { language: 'en', currency: 'NZD', symbol: '$' },
  GW: { language: 'pt', currency: 'XOF', symbol: 'CFA' },
  GU: { language: 'en', currency: 'USD', symbol: '$' },
  GT: { language: 'es', currency: 'GTQ', symbol: 'Q' },
  GS: { language: 'en', currency: 'GBP', symbol: '£' },
  GR: { language: 'el', currency: 'EUR', symbol: '€' },
  GQ: { language: 'es', currency: 'XAF', symbol: 'FCFA' },
  GP: { language: 'fr', currency: 'EUR', symbol: '€' },
  JP: { language: 'ja', currency: 'JPY', symbol: '￥' },
  GY: { language: 'en', currency: 'GYD' },
  GG: { language: 'en', currency: 'GBP', symbol: '£' },
  GF: { language: 'fr', currency: 'EUR', symbol: '€' },
  GE: { language: 'ka', currency: 'USD', symbol: '$' },
  GD: { language: 'en', currency: 'XCD' },
  GB: { language: 'en', currency: 'GBP', symbol: '£' },
  GA: { language: 'fr', currency: 'EUR', symbol: '€' },
  SV: { language: 'es', currency: 'USD', symbol: '$' },
  GN: { language: 'fr', currency: 'GNF', symbol: 'FG' },
  GM: { language: 'en', currency: 'GMD' },
  GL: { language: 'kl', currency: 'EUR', symbol: '€' },
  GI: { language: 'en', currency: 'GIP' },
  GH: { language: 'en', currency: 'GHS', symbol: 'GH₵' },
  OM: { language: 'ar', currency: 'USD', symbol: '$' },
  TN: { language: 'ar', currency: 'USD', symbol: '$' },
  JO: { language: 'ar', currency: 'JOD', symbol: 'د.أ.' },
  HR: { language: 'hr', currency: 'EUR', symbol: '€' },
  HT: { language: 'fr', currency: 'HTG' },
  HU: { language: 'hu', currency: 'HUF', symbol: 'Ft' },
  HK: { language: 'zh', currency: 'HKD', symbol: '$' },
  HN: { language: 'es', currency: 'HNL', symbol: 'L' },
  HM: { language: 'en', currency: 'AUD', symbol: '$' },
  VE: { language: 'es', currency: 'VEF', symbol: 'Bs.F.' },
  PR: { language: 'es', currency: 'USD', symbol: '$' },
  PS: { language: 'ar', currency: 'ILS', symbol: '₪' },
  PW: { language: 'en', currency: 'USD', symbol: '$' },
  PT: { language: 'pt', currency: 'EUR', symbol: '€' },
  SJ: { language: 'no', currency: 'NOK', symbol: 'kr' },
  PY: { language: 'es', currency: 'USD', symbol: '$' },
  IQ: { language: 'ar', currency: 'IQD', symbol: 'د.ع.' },
  PA: { language: 'es', currency: 'USD', symbol: '$' },
  PF: { language: 'fr', currency: 'EUR', symbol: '€' },
  PG: { language: 'en', currency: 'USD', symbol: '$' },
  PE: { language: 'es', currency: 'USD', symbol: '$' },
  PK: { language: 'ur', currency: 'USD', symbol: '$' },
  PH: { language: 'en', currency: 'USD', symbol: '$' },
  PN: { language: 'en', currency: 'NZD', symbol: '$' },
  PL: { language: 'pl', currency: 'PLN', symbol: 'zł' },
  PM: { language: 'fr', currency: 'EUR', symbol: '€' },
  ZM: { language: 'en', currency: 'USD', symbol: '$' },
  EH: { language: 'ar', currency: 'MAD', symbol: 'د.م.' },
  EE: { language: 'et', currency: 'EUR', symbol: '€' },
  EG: { language: 'ar', currency: 'EGP', symbol: 'ج.م.' },
  ZA: { language: 'en', currency: 'ZAR', symbol: 'R' },
  EC: { language: 'es', currency: 'USD', symbol: '$' },
  IT: { language: 'it', currency: 'EUR', symbol: '€' },
  VN: { language: 'vi', currency: 'VND', symbol: '₫' },
  SB: { language: 'en', currency: 'USD', symbol: '$' },
  ET: { language: 'am', currency: 'ETB', symbol: 'Br' },
  SO: { language: 'so', currency: 'SOS', symbol: 'Ssh' },
  ZW: { language: 'en', currency: 'ZWL', symbol: 'ZWL$' },
  SA: { language: 'ar', currency: 'USD', symbol: '$' },
  ES: { language: 'es', currency: 'EUR', symbol: '€' },
  ER: { language: 'ti', currency: 'ERN', symbol: 'Nfk' },
  ME: { language: 'sr', currency: 'EUR', symbol: '€' },
  MD: { language: 'ro', currency: 'EUR', symbol: '€' },
  MG: { language: 'mg', currency: 'USD', symbol: '$' },
  MF: { language: 'fr', currency: 'EUR', symbol: '€' },
  MA: { language: 'fr', currency: 'USD', symbol: '$' },
  MC: { language: 'fr', currency: 'EUR', symbol: '€' },
  UZ: { language: 'uz', currency: 'USD', symbol: '$' },
  MM: { language: 'my', currency: 'MMK', symbol: 'K' },
  ML: { language: 'fr', currency: 'XOF', symbol: 'CFA' },
  MO: { language: 'zh', currency: 'MOP', symbol: 'MOP$' },
  MN: { language: 'mn', currency: 'USD', symbol: '$' },
  MH: { language: 'en', currency: 'USD', symbol: '$' },
  MK: { language: 'mk', currency: 'EUR', symbol: '€' },
  MU: { language: 'fr', currency: 'USD', symbol: '$' },
  MT: { language: 'mt', currency: 'EUR', symbol: '€' },
  MW: { language: 'en', currency: 'USD', symbol: '$' },
  MV: { language: 'dv', currency: 'USD', symbol: '$' },
  MQ: { language: 'fr', currency: 'EUR', symbol: '€' },
  MP: { language: 'en', currency: 'USD', symbol: '$' },
  MS: { language: 'en', currency: 'USD', symbol: '$' },
  MR: { language: 'ar', currency: 'USD', symbol: '$' },
  IM: { language: 'en', currency: 'GBP', symbol: '£' },
  UG: { language: 'en', currency: 'USD', symbol: '$' },
  TZ: { language: 'sw', currency: 'USD', symbol: '$' },
  MY: { language: 'ms', currency: 'USD', symbol: '$' },
  MX: { language: 'es', currency: 'MXN', symbol: 'MX$' },
  IL: { language: 'he', currency: 'ILS', symbol: '₪' },
  FR: { language: 'fr', currency: 'EUR', symbol: '€' },
  IO: { language: 'en', currency: 'USD', symbol: '$' },
  SH: { language: 'en', currency: 'SHP' },
  FI: { language: 'fi', currency: 'EUR', symbol: '€' },
  FJ: { language: 'en', currency: 'FJD' },
  FK: { language: 'en', currency: 'FKP' },
  FM: { language: 'en', currency: 'USD', symbol: '$' },
  FO: { language: 'fo', currency: 'DKK', symbol: 'kr' },
  NI: { language: 'es', currency: 'NIO', symbol: 'C$' },
  NL: { language: 'nl', currency: 'EUR', symbol: '€' },
  NO: { language: 'nb', currency: 'NOK', symbol: 'kr' },
  NA: { language: 'en', currency: 'USD', symbol: '$' },
  VU: { language: 'bi', currency: 'USD', symbol: '$' },
  NC: { language: 'fr', currency: 'USD', symbol: '$' },
  NE: { language: 'fr', currency: 'USD', symbol: '$' },
  NF: { language: 'en', currency: 'AUD', symbol: '$' },
  NG: { language: 'en', currency: 'USD', symbol: '$' },
  NZ: { language: 'mi', currency: 'NZD', symbol: '$' },
  NP: { language: 'ne', currency: 'USD', symbol: '$' },
  NR: { language: 'na', currency: 'AUD', symbol: '$' },
  NU: { language: 'en', currency: 'NZD', symbol: '$' },
  CK: { language: 'en', currency: 'NZD', symbol: '$' },
  XK: { language: 'en', currency: 'EUR', symbol: '€' },
  CI: { language: 'fr', currency: 'XOF', symbol: 'CFA' },
  CH: { language: 'de', currency: 'CHF', symbol: 'CHF' },
  CO: { language: 'es', currency: 'COP', symbol: '$' },
  CN: { language: 'zh', currency: 'CNY', symbol: 'CN¥' },
  CM: { language: 'fr', currency: 'XAF', symbol: 'FCFA' },
  CL: { language: 'es', currency: 'CLP', symbol: '$' },
  CC: { language: 'en', currency: 'AUD', symbol: '$' },
  CA: { language: 'en', currency: 'CAD', symbol: '$' },
  CG: { language: 'fr', currency: 'XAF', symbol: 'FCFA' },
  CF: { language: 'fr', currency: 'XAF', symbol: 'FCFA' },
  CD: { language: 'fr', currency: 'CDF', symbol: 'FrCD' },
  CZ: { language: 'cs', currency: 'CZK', symbol: 'Kč' },
  CY: { language: 'el', currency: 'EUR', symbol: '€' },
  CX: { language: 'en', currency: 'AUD', symbol: '$' },
  CR: { language: 'es', currency: 'CRC', symbol: '₡' },
  CW: { language: 'nl', currency: 'EUR', symbol: '€' },
  CV: { language: 'pt', currency: 'CVE', symbol: 'CV$' },
  CU: { language: 'es', currency: 'CUP' },
  SZ: { language: 'en', currency: 'USD', symbol: '$' },
  SY: { language: 'ar', currency: 'SYP', symbol: 'ل.س.' },
  SX: { language: 'nl', currency: 'EUR', symbol: '€' },
  KG: { language: 'ky', currency: 'USD', symbol: '$' },
  KE: { language: 'sw', currency: 'USD', symbol: '$' },
  SS: { language: 'en', currency: 'SSP' },
  SR: { language: 'nl', currency: 'USD', symbol: '$' },
  KI: { language: 'en', currency: 'AUD', symbol: '$' },
  KH: { language: 'km', currency: 'USD', symbol: '$' },
  KN: { language: 'en', currency: 'USD', symbol: '$' },
  KM: { language: 'ar', currency: 'USD', symbol: '$' },
  ST: { language: 'pt', currency: 'USD', symbol: '$' },
  SK: { language: 'sk', currency: 'EUR', symbol: '€' },
  KR: { language: 'ko', currency: 'KRW', symbol: '₩' },
  SI: { language: 'sl', currency: 'EUR', symbol: '€' },
  KP: { language: 'ko', currency: 'KPW' },
  KW: { language: 'ar', currency: 'USD', symbol: '$' },
  SN: { language: 'fr', currency: 'USD', symbol: '$' },
  SM: { language: 'it', currency: 'EUR', symbol: '€' },
  SL: { language: 'en', currency: 'USD', symbol: '$' },
  SC: { language: 'fr', currency: 'USD', symbol: '$' },
  KZ: { language: 'kk', currency: 'USD', symbol: '$' },
  KY: { language: 'en', currency: 'USD', symbol: '$' },
  SG: { language: 'zh', currency: 'SGD', symbol: '$' },
  SE: { language: 'sv', currency: 'SEK', symbol: 'kr' },
  SD: { language: 'ar', currency: 'SDG', symbol: 'SDG' },
  DO: { language: 'es', currency: 'DOP', symbol: 'RD$' },
  DM: { language: 'en', currency: 'XCD' },
  DJ: { language: 'fr', currency: 'DJF', symbol: 'Fdj' },
  DK: { language: 'da', currency: 'DKK', symbol: 'kr' },
  VG: { language: 'en', currency: 'USD', symbol: '$' },
  DE: { language: 'de', currency: 'EUR', symbol: '€' },
  YE: { language: 'ar', currency: 'YER', symbol: 'ر.ي.' },
  DZ: { language: 'ar', currency: 'DZD', symbol: 'د.ج.' },
  US: { language: 'en', currency: 'USD', symbol: '$' },
  UY: { language: 'es', currency: 'EUR', symbol: '€' },
  YT: { language: 'fr', currency: 'EUR', symbol: '€' },
  UM: { language: 'en', currency: 'USD', symbol: '$' },
  LB: { language: 'ar', currency: 'USD', symbol: '$' },
  LC: { language: 'en', currency: 'USD', symbol: '$' },
  LA: { language: 'lo', currency: 'USD', symbol: '$' },
  TV: { language: 'en', currency: 'AUD', symbol: '$' },
  TW: { language: 'zh', currency: 'TWD', symbol: 'NT$' },
  TT: { language: 'en', currency: 'USD', symbol: '$' },
  TR: { language: 'tr', currency: 'USD', symbol: '$' },
  LK: { language: 'si', currency: 'USD', symbol: '$' },
  LI: { language: 'de', currency: 'CHF', symbol: 'CHF' },
  LV: { language: 'lv', currency: 'EUR', symbol: '€' },
  TO: { language: 'en', currency: 'USD', symbol: '$' },
  LT: { language: 'lt', currency: 'EUR', symbol: '€' },
  LU: { language: 'lb', currency: 'EUR', symbol: '€' },
  LR: { language: 'en', currency: 'USD', symbol: '$' },
  LS: { language: 'en', currency: 'USD', symbol: '$' },
  TH: { language: 'th', currency: 'THB', symbol: '฿' },
  TF: { language: 'fr', currency: 'EUR', symbol: '€' },
  TG: { language: 'fr', currency: 'USD', symbol: '$' },
  TD: { language: 'fr', currency: 'USD', symbol: '$' },
  TC: { language: 'en', currency: 'USD', symbol: '$' },
  LY: { language: 'ar', currency: 'LYD', symbol: 'د.ل.' },
  VA: { language: 'it', currency: 'EUR', symbol: '€' },
  VC: { language: 'en', currency: 'USD', symbol: '$' },
  AE: { language: 'ar', currency: 'AED', symbol: 'د.إ.' },
  AD: { language: 'ca', currency: 'EUR', symbol: '€' },
  AG: { language: 'en', currency: 'XCD' },
  AF: { language: 'fa', currency: 'AFN', symbol: '؋' },
  AI: { language: 'en', currency: 'USD', symbol: '$' },
  VI: { language: 'en', currency: 'USD', symbol: '$' },
  IS: { language: 'is', currency: 'EUR', symbol: '€' },
  IR: { language: 'fa', currency: 'IRR', symbol: '﷼' },
  AM: { language: 'hy', currency: 'AMD', symbol: 'դր.' },
  AL: { language: 'sq', currency: 'EUR', symbol: '€' },
  AO: { language: 'pt', currency: 'AOA' },
  AQ: { language: 'en', currency: 'RUB', symbol: '₽.' },
  AS: { language: 'en', currency: 'USD', symbol: '$' },
  AR: { language: 'es', currency: 'ARS', symbol: '$' },
  AU: { language: 'en', currency: 'AUD', symbol: '$' },
  AT: { language: 'de', currency: 'EUR', symbol: '€' },
  AW: { language: 'nl', currency: 'AWG' },
  IN: { language: 'hi', currency: 'INR', symbol: 'টকা' },
  AX: { language: 'sv', currency: 'EUR', symbol: '€' },
  AZ: { language: 'az', currency: 'AZN', symbol: 'ман.' },
  IE: { language: 'en', currency: 'EUR', symbol: '€' },
  ID: { language: 'id', currency: 'IDR', symbol: 'Rp' },
  UA: { language: 'uk', currency: 'UAH', symbol: '₴' },
  QA: { language: 'ar', currency: 'USD', symbol: '$' },
  MZ: { language: 'pt', currency: 'USD', symbol: '$' }
}
